module.exports = __webpack_public_path__ + "static/media/traffic-moderate.11c51682.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traffic-moderate.svg
// module id = 905
// module chunks = 0